import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from 'components/ui/Header';
import Footer from 'components/ui/Footer';
import FloatingActionButtons from 'components/ui/FloatingActionButtons';
import PopupAdvertisement from 'components/ui/PopupAdvertisement';
import { AnimatedElement, ScrollReveal, ParallaxScroll } from 'components/ui/animations';
import HeroCarousel from './components/HeroCarousel';
import WelcomeSection from './components/WelcomeSection';
import DiscountBanner from './components/DiscountBanner';
import SpecialOffersGrid from './components/SpecialOffersGrid';
import AccommodationShowcase from './components/AccommodationShowcase';
import ResortsSection from './components/ResortsSection';
import FeaturedExperiences from './components/FeaturedExperiences';
import NearbyAttractions from './components/NearbyAttractions';
import ClientReviews from './components/ClientReviews';

const HomeLanding = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300 && !hasScrolled) {
        setHasScrolled(true);
        // Show popup after user starts scrolling
        setTimeout(() => {
          setShowPopup(true);
        }, 1000);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasScrolled]);

  const handleBookNowClick = (selectedItem = null) => {
    // Navigate to booking engine with optional pre-selected item
    if (selectedItem) {
      navigate('/booking-engine', { state: { selectedItem } });
    } else {
      navigate('/booking-engine');
    }
  };

  const handleViewDetailsClick = (accommodation) => {
    // Navigate to accommodation details with selected room
    navigate('/accommodation-details', { state: { selectedRoom: accommodation } });
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <Header />

      {/* Popup Advertisement */}
      <PopupAdvertisement 
        isVisible={showPopup}
        onClose={handleClosePopup}
      />

      {/* Main Content */}
      <main className="pt-16">
        {/* Hero Carousel Section */}
        <HeroCarousel onBookNowClick={handleBookNowClick} />

        {/* Welcome Section */}
        <WelcomeSection />

        {/* Discount Banner */}
        <DiscountBanner onBookNowClick={handleBookNowClick} />

        {/* Special Offers Grid */}
        <SpecialOffersGrid onBookNowClick={handleBookNowClick} />

        {/* Resorts Section */}
        <ResortsSection />

        {/* Accommodation Showcase */}
        <AccommodationShowcase 
          onBookNowClick={handleBookNowClick}
          onViewDetailsClick={handleViewDetailsClick}
        />

        {/* Featured Experiences */}
        <FeaturedExperiences />

        {/* Nearby Attractions */}
        <NearbyAttractions />

        {/* Client Reviews */}
        <ClientReviews />
      </main>

      {/* Footer */}
      <Footer />

      {/* Floating Action Buttons */}
      <FloatingActionButtons />
    </div>
  );
};

export default HomeLanding;